import type { AxiosInstance, AxiosResponse } from 'axios';

// --- Report ---

export function getLatestReport(api: AxiosInstance): Promise<AxiosResponse> {
    return api.get('/kontroledge/fortiflex/report');
}

export function getReportHistory(
    api: AxiosInstance,
    limit = 90,
    offset = 0
): Promise<AxiosResponse> {
    return api.get(
        `/kontroledge/fortiflex/report/history?limit=${limit}&offset=${offset}`
    );
}

export function triggerReportGeneration(
    api: AxiosInstance
): Promise<AxiosResponse> {
    return api.post('/kontroledge/fortiflex/report/generate');
}

export function getJobStatus(api: AxiosInstance): Promise<AxiosResponse> {
    return api.get('/kontroledge/fortiflex/report/status');
}

// --- Packs ---

export function getPacks(api: AxiosInstance): Promise<AxiosResponse> {
    return api.get('/kontroledge/fortiflex/packs');
}

export function createPack(
    api: AxiosInstance,
    data: {
        packNumber: string;
        packIndex: number;
        totalPoints: number;
        startDate: string;
        expirationDate: string;
        notes?: string;
    }
): Promise<AxiosResponse> {
    return api.post('/kontroledge/fortiflex/packs', data);
}

export function updatePack(
    api: AxiosInstance,
    id: number,
    data: Record<string, unknown>
): Promise<AxiosResponse> {
    return api.put(`/kontroledge/fortiflex/packs/${id}`, data);
}

export function deletePack(
    api: AxiosInstance,
    id: number
): Promise<AxiosResponse> {
    return api.delete(`/kontroledge/fortiflex/packs/${id}`);
}

// --- Account History (analytics) ---

export function getAccountHistory(
    api: AxiosInstance,
    days = 90
): Promise<AxiosResponse> {
    return api.get(`/kontroledge/fortiflex/history/accounts?days=${days}`);
}

// --- Alert Recipients ---

export function getAlertRecipients(api: AxiosInstance): Promise<AxiosResponse> {
    return api.get('/kontroledge/fortiflex/alert-recipients');
}

export function createAlertRecipient(
    api: AxiosInstance,
    data: { email: string; name?: string; enabled?: boolean }
): Promise<AxiosResponse> {
    return api.post('/kontroledge/fortiflex/alert-recipients', data);
}

export function updateAlertRecipient(
    api: AxiosInstance,
    id: number,
    data: { email?: string; name?: string; enabled?: boolean }
): Promise<AxiosResponse> {
    return api.put(`/kontroledge/fortiflex/alert-recipients/${id}`, data);
}

export function deleteAlertRecipient(
    api: AxiosInstance,
    id: number
): Promise<AxiosResponse> {
    return api.delete(`/kontroledge/fortiflex/alert-recipients/${id}`);
}

// --- Account Labels ---

export function getAccountLabels(api: AxiosInstance): Promise<AxiosResponse> {
    return api.get('/kontroledge/fortiflex/accounts');
}

export function createAccountLabel(
    api: AxiosInstance,
    data: { accountId: string; label: string }
): Promise<AxiosResponse> {
    return api.post('/kontroledge/fortiflex/accounts', data);
}

export function updateAccountLabel(
    api: AxiosInstance,
    id: number,
    data: { label?: string; accountId?: string }
): Promise<AxiosResponse> {
    return api.put(`/kontroledge/fortiflex/accounts/${id}`, data);
}

export function deleteAccountLabel(
    api: AxiosInstance,
    id: number
): Promise<AxiosResponse> {
    return api.delete(`/kontroledge/fortiflex/accounts/${id}`);
}
